import { Filter, Result } from './../../../interfaces/Ordenes';
import { SnackbarService } from './../../../../services/snackbar.service';
import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { ReportOrderService } from '../../../services/report-order.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { InfoComponent } from './info/info.component';
import { Subscription, Observable } from 'rxjs';
import { GlobalService } from 'src/app/core/services/global.service';
import { ThemePalette } from '@angular/material/core';
import { _isNumberValue } from '@angular/cdk/coercion';
import { ConversionService } from 'src/app/core/finanzas/services/conversion.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResultOrden } from '../../../interfaces/OrdenesInstalaciones.interface';
import { OrdenesInstalacionService } from '../../../services/ordenes-instalacion.service';
import { ConfirmDialogComponent } from 'src/app/core/home/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  private orderservice = inject(ReportOrderService)
  private ordenesS = inject(OrdenesInstalacionService)
  private global = inject(GlobalService)

  constructor(private clipboard: Clipboard, public dialog: MatDialog, private conversionService: ConversionService, private snackbar: SnackbarService, private snackBar: MatSnackBar,) { }
  @Input()
  sub!: Subscription;
  datos!: Array<ResultOrden>;
  infor!: Object;
  filter!: Filter;
  dataSource = new MatTableDataSource<ResultOrden>(this.datos);
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  searching = new FormGroup({
    search: new FormControl<string | null>(''),
    checked: new FormControl<string | null>('')
  });
  color: ThemePalette = 'accent';
  // checked = false;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  displayedColumns: string[] = ['order','seller', 'client', 'client_type_name', 'payment', 'finish', 'date',  'create_by', 'action'];
  length_pagination: number = 0;
  pageSize: number = 1;
  confirmDisabled: string = '';

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  ngOnInit(): void {
    this.getOrdenes();
  }
  getPermisos(name: string): boolean {
    return this.global.Permissions(name);
  }
  getOrdenes() {
    // this.pageSize = 1;
    this.orderservice.getOrder()
      .then((data) => {
        this.dataSource = new MatTableDataSource<ResultOrden>(data.results);
        this.dataSource.paginator = this.paginator;
        this.length_pagination = data.count;
      })
      .catch((err) => {
        console.log(err, 'error')
      });
  }
  getOrdenesParamas() {
    this.pageSize = 1;
    this.orderservice.getOrderParams(this.bodyFilter(this.filter))
      .then((data) => {
        // console.log(data.results)
        this.dataSource = new MatTableDataSource<ResultOrden>(data.results);
        // this.dataSource.paginator = this.paginator;
        this.length_pagination = data.count;
      })
      .catch((err) => {
        console.log(err, 'error')
      });
  }


  ModalContract(data: any) {
    this.dialog.open(InfoComponent, {
      width: window.innerWidth > 696 ? '40%' : 'auto',
      data,
    });
  }

  bodyFilter(filter: Filter) {
    // console.log(this.searching.value.search, 'value')
    if (this.range.value.start != null) {
      const valor = this.range.value;
      filter = {
        since: this.conversionService.formatDate(valor.start),
        until: this.conversionService.formatDate(valor.end),
        confirmation: this.searching.value.checked,
        page: this.pageSize,
        search: this.searching.value.search || ''
      }
      /*  fn(filter) */
      return filter
    } else {
      filter = {
        since: '',
        until: '',
        confirmation: this.searching.value.checked,
        page: this.pageSize,
        search: this.searching.value.search || ''
      }
      return filter
      /*  fn(filter) */
    }
  }

  pagination(e: any): void {
    this.pageSize = e.pageIndex + 1;
    this.orderservice.getOrderParams(this.bodyFilter(this.filter))
      .then((data) => {
        this.dataSource = new MatTableDataSource<ResultOrden>(data.results);
        this.length_pagination = data.count;
      })
      .catch((err) => {
        console.log(err, 'error')
      });
  }
  sendConfirmation(id: number): void {
     this.dataSource.filteredData.filter(contr => {
      if (contr.id == id) {
        // console.log(contr, 'info')
       const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          data: {
            message: `Enviar mensaje de confirmación a la Orden #${contr.order}`
          },
        });
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
            // this.confirmDisabled = id.toString();
            let body = {
              confirmar: contr.order
            }
            // console.log(this.confirmDisabled, 'confir')
            this.orderservice.postConfirmOrder(body).then((result) => {
              // console.log(result, 'results')
              this.snackbar.openSnackBar("Enviado con exito!")
              this.getOrdenes();
            }).catch((err) => {
              console.log(err, 'error')
              this.snackbar.openSnackBar("Ups! Ocurrió un error, contacte con el Administrador")
            });
          }
        });
       }
    })

  }
  copyToClipboard(value: string): void {
    // console.log('click', value)
    this.clipboard.copy(value);
    this.snackBar.open('Orden copiado al portapapeles!', '', {
      duration: 2000,
      panelClass: 'snackbar'
    });
  }
}//end-code
